
import CartCheckoutLine from '../CheckoutLine/CheckoutLine.vue'
import currencyFormatter from '../../../methods/currencyFormatter'
import verifyLabel from '../../../methods/verifyLabel'

export default {
    name: 'checkout-cart',
    data(){
        return {
            
        }
    },
    computed:{
        labels() {
            if (this.$store.state.main.labels) {
                return this.$store.state.main.labels
            }
        },
        cartItems() {
            if (this.$store.state.cart.checkoutCart.cartItems) {
                return this.$store.state.cart.checkoutCart.cartItems
            }
        },
        scrollbarMargin() {
            if (this.$store.state.cart.checkoutCart.cartItems) {
                return (this.$store.state.cart.checkoutCart.cartItems.length > 3)
            }
        },
        cartTotalExclVatLabel() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return this.$store.state.cart.checkoutCart.totals.cartTotalExclVatLabel
            }
        },
        cartTotalExclVat() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return currencyFormatter(this.$store.state.cart.checkoutCart.totals.totalExclVat.currency, this.$store.state.cart.checkoutCart.totals.cartTotalExclVat.amount)
            }
        },
        totalExVatLabel() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return this.$store.state.cart.checkoutCart.totals.totalExclVatLabel
            }
        },
        totalExVat() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return currencyFormatter(this.$store.state.cart.checkoutCart.totals.totalExclVat.currency, this.$store.state.cart.checkoutCart.totals.totalExclVat.amount)
            }
        },
        hasDiscount() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return this.$store.state.cart.checkoutCart.totals.hasDiscount
            }
        },
        discountLabel() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return this.$store.state.cart.checkoutCart.totals.discountLabel
            }
        },
        couponCode() {
            if (this.$store.state.cart.checkoutCart) {
                return this.$store.state.cart.checkoutCart.couponCode
            }
        },
        discount() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return currencyFormatter(this.$store.state.cart.checkoutCart.totals.discount.currency, this.$store.state.cart.checkoutCart.totals.discount.amount)
            }
        },
        vatLabel() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return this.$store.state.cart.checkoutCart.totals.vatLabel
            }
        },
        vat() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return currencyFormatter(this.$store.state.cart.checkoutCart.totals.vat.currency, this.$store.state.cart.checkoutCart.totals.vat.amount)
            }
        },
        // Optional-chained rather than following the guard style above, because a missing
        // handlingFee object must read as "no fee" instead of throwing while the cart loads.
        hasHandlingFee() {
            return this.$store.state.cart.checkoutCart.totals?.handlingFee?.amount > 0
        },
        handlingFeeLabel() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return this.$store.state.cart.checkoutCart.totals.handlingFeeLabel
            }
        },
        handlingFee() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return currencyFormatter(this.$store.state.cart.checkoutCart.totals.handlingFee.currency, this.$store.state.cart.checkoutCart.totals.handlingFee.amount)
            }
        },
        totalIncVatLabel() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return this.$store.state.cart.checkoutCart.totals.totalInclVatLabel
            }
        },
        totalIncVat() {
            if (this.$store.state.cart.checkoutCart.totals) {
                return currencyFormatter(this.$store.state.cart.checkoutCart.totals.totalInclVat.currency, this.$store.state.cart.checkoutCart.totals.totalInclVat.amount)
            }
        },
        itemCountInCart(){
            return this.cartItems.length ? this.cartItems.length : 0
        },
        
    },
    methods: {
        verifyLabel(displayName) {
            if (this.$store.state.main.labels) {
                return verifyLabel(displayName,this.labels)
            } else {
                return ""
            }
        }
    },
    mounted: function() {
        this.$store.dispatch("cart/getCart")
    },
    components: {
        CartCheckoutLine
    }
  
}


